import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useIdentity } from '@office-start/identity-service';
import { useMemo } from 'react';
export var useUserStorageOptions = function () {
    var officeComponentContext = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    return useMemo(function () {
        if (!officeComponentContext || !identity) {
            return null;
        }
        var options = {
            correlationId: officeComponentContext.correlationId,
            getAccessToken: officeComponentContext.getAccessToken,
            getIdentity: function () { return Promise.resolve(identity); },
            inMockMode: officeComponentContext.inMockMode,
            jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
            officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
            workload: officeComponentContext.workload,
        };
        return options;
    }, [identity, officeComponentContext]);
};
//# sourceMappingURL=useUserStorageOptions.js.map